import { base64UrlDecode } from "../general";
import { retrieveLaunchParams } from "@telegram-apps/sdk-react";

export type TmaStartParams = {
  utm?: string;
  partner?: string;
  route?: string;
};

export const getTmaStartParams = (): TmaStartParams | null => {
  const launchParams = retrieveLaunchParams();
  const { tgWebAppStartParam: startParam } = launchParams;

  if (!startParam) {
    return null;
  }

  try {
    return base64UrlDecode<TmaStartParams>(startParam);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error("Failed to decode TMA start param:", error);
    return null;
  }
};
